// assets
import { IconDashboard } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| DASHBOARD MENU ITEM ||============================== //

const icons = {
  IconDashboard
};

const dashboard: NavItemType = {
  id: 'dashboard',
  title: 'dashboard',
  icon: icons.IconDashboard,
  type: 'group',
  url: '/dashboard'
};

export default dashboard;
